import React from "react";

import "./style.scss";
import Helmet from "./common/helmet";
import NavBar from "./common/navbar";
import SubMenu from "./common/submenu";
import Contacto from "./layouts/contacto/contacto";
import Footer from "./common/footer";
import Siguenos from "./common/siguenos";

const Layout = ({ children }) => (
  <div>
    <Helmet />
    <SubMenu />
    <NavBar />
    <Contacto />
    <Siguenos />
    <Footer />
  </div>
);

export default Layout;
